import { Link } from "react-router-dom";
import { ArrowRight, Type, Moon, Hash, Shapes, Brain } from "lucide-react";

const games = [
  { to: "/games/alphabet", label: "Alphabet & Phonics", desc: "Tap a letter, hear a sound.", icon: Type, bg: "bg-brand-red", text: "text-white" },
  { to: "/games/islamic", label: "Islamic Basics", desc: "Arabic letters, duas & colors.", icon: Moon, bg: "bg-brand-green", text: "text-white" },
  { to: "/games/counting", label: "Counting Fun", desc: "How many friends do you see?", icon: Hash, bg: "bg-brand-yellow", text: "text-brand-ink" },
  { to: "/games/shapes", label: "Shapes & Colors", desc: "Match shapes and colors.", icon: Shapes, bg: "bg-brand-purple", text: "text-brand-ink" },
  { to: "/games/memory", label: "Memory Pairs", desc: "Flip and find the pairs.", icon: Brain, bg: "bg-brand-blue", text: "text-brand-ink" },
];

export default function GamesTeaser() {
  return (
    <section id="games" className="relative py-20 md:py-28" data-testid="games-teaser-section">
      <div className="mx-auto max-w-6xl px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-xl">
            <p className="uppercase tracking-widest text-sm font-bold text-brand-red">Play & Learn</p>
            <h2 className="mt-3 font-display text-4xl md:text-5xl font-semibold text-brand-ink">
              Little games. <span className="text-brand-green">Big grins.</span>
            </h2>
            <p className="mt-4 text-lg text-brand-ink/80">
              Free interactive games your little one can play right from home — with a grown-up nearby to cheer them on.
            </p>
          </div>
          <Link
            to="/games"
            className="inline-flex items-center gap-2 rounded-full bg-brand-ink text-white font-bold px-6 py-3 btn-brutal self-start md:self-auto"
            data-testid="games-see-all"
          >
            See all games <ArrowRight size={18} />
          </Link>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {games.map((g, idx) => {
            const Icon = g.icon;
            return (
              <Link
                key={g.label}
                to={g.to}
                data-testid={`game-card-${g.label.toLowerCase().replace(/\s|&/g, "")}`}
                className={`group relative rounded-3xl border-[3px] border-brand-ink ${g.bg} ${g.text} p-6 shadow-brutal-sm lift-hover overflow-hidden ${idx === 0 ? "lg:col-span-1" : ""}`}
              >
                <div className="absolute -right-8 -bottom-8 w-32 h-32 rounded-full bg-white/20" />
                <div className="w-14 h-14 rounded-2xl bg-white border-2 border-brand-ink flex items-center justify-center">
                  <Icon size={26} strokeWidth={2.5} className="text-brand-ink" />
                </div>
                <h3 className="mt-4 font-display text-2xl font-semibold leading-tight">{g.label}</h3>
                <p className={`mt-1 text-sm font-semibold ${g.text === "text-white" ? "text-white/85" : "text-brand-ink/70"}`}>
                  {g.desc}
                </p>
                <p className="mt-5 font-bold text-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                  Play now <ArrowRight size={16} />
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
